import { getEnumValues } from './get-enum-values';
export enum AthleteMetric{
	Acceleration='acceleration',
	Speed='speed',
	Agility='agility',
	Power='power',
	Recovery='recovery',
}
export const AthleteMetricValues = getEnumValues<AthleteMetric>(AthleteMetric);